import styles from './GalleryBlock.module.scss';
import React, { ReactElement, useState } from 'react';
import { ImagePortrait } from '@kursk/components/ui/ImagePortrait/ImagePortrait';
import { ImageDescription } from '@kursk/components/ui/ImageDescription/ImageDescription';
import { Carousel, ICarouselOptions } from "@kursk/components/ui/Carousel/Carousel";
import _ from "lodash";
import { IImage } from "@common/redux/types/images";
import { CarouselButtonGroup } from "@kursk/components/ui/CarouselButtonGroup/CarouselButtonGroup";

interface IProps {
  images: any[],
}

export const GalleryBlock = ({ images }: IProps): ReactElement => {

  const [slideIndex, setSlideIndex] = useState(0);

  if (images.length === 0) {
    return null;
  }

  if (images.length === 1) {
    const [image] = images;
    return (
      <div className={styles.imgBlockWrapper}>
        <div className={styles.imgBlock}>
          <ImagePortrait
            image={image}
            useFullscreen={true}
          />
        </div>
        <ImageDescription image={image}/>
      </div>
    );
  } else {

    const options: ICarouselOptions = {
      swipeable: true,
      infinite: true,
      renderButtonGroupOutside: true,
      partialVisible: true,
    };

    const renderImage = (image: IImage) => (
      <ImagePortrait
        image={image}
        useFullscreen={true}
        className={styles.galleryImage}
        carouselSlides={images}
      />
    )

    return (
      <div className={styles.galleryWrapper}>
        <Carousel
          carouselOptions={options}
          onIndexChange={(index) => {
            setTimeout(() => {
              setSlideIndex(index);
            }, 400)
          }}
          Buttons={<CarouselButtonGroup className={styles.galleryButtons} buttonClassName={styles.galleryButton}/>}
        >
          {_.map(images, renderImage)}
        </Carousel>
        <ImageDescription image={images[slideIndex]}/>
      </div>
    );
  }
};
